<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-comment</v-icon>
        <h1 class="title ml-2">Notificaciones push</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-btn
              @click="showNew = true"
              color="primary"
            >
              <v-icon left>fas fa-plus</v-icon>
              Agregar
            </v-btn>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Título</th>
                <th>Mensaje</th>
                <th>Fecha</th>
                <th>Enviado</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in notificaciones" :key="item.id">
                <td>{{item.titulo}}</td>
                <td>{{item.contenido}}</td>
                <td>{{item.fecha}}</td>
                <td>
                  <v-icon color="success" v-if="item.enviado">fas fa-check</v-icon>
                  <v-icon color="primary" v-else>fas fa-clock</v-icon>
                </td>
                <td class="max-width-120">
                  <v-btn fab text color="error" @click="deleteItem(item.id)">
                    <v-icon>fas fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-pagination v-model="page" :length="pages" />
      </v-card-text>
    </v-card>
    <v-dialog v-model="showNew" max-width="600">
      <!-- <send-notificacion
        @close="showNew = false"
        @send="sendNotificacion"
      ></send-notificacion> -->
      <AddNotificacion
        @close="showNew = false"
        @saved="refresh()"
      ></AddNotificacion>
    </v-dialog>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
// import SendNotificacion from '../components/SendNotificacion'
import AddNotificacion from '../components/AddNotificacion'
export default {
  data () {
    return {
      notificaciones: [],
      page: 1,
      pages: 1,
      showNew: false
    }
  },
  components: {
    // SendNotificacion
    AddNotificacion
  },
  computed: {
    params () {
      return `?_limit=25&_sort=createdAt:DESC&_start=${this.page * 25}`
    }
  },
  methods: {
    async getPages () {
      const { data } = await this.$http.notificaciones.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getNotificaciones () {
      const skip = (this.pages - 1) * 25
      const { data } = await this.$http.notificaciones.get(
        `?_limit=25&_sort=createdAt:DESC&_start=${skip}`
      )
      this.notificaciones = data.map(i => {
        return {
          ...i,
          fecha: dayjs(i.fecha).format('DD-MM-YYYY HH:mm')
        }
      })
    },
    async deleteItem (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        await this.$http.notificaciones.delete(`/${id}`)
        this.getNotificaciones()
      }
    },
    async sendNotificacion (notificacion) {
      try {
        await this.$http.notificaciones.post('', notificacion)
        this.getNotificaciones()
        this.showNew = false
      } catch (error) {
        window.alert('Ocurrio un error al enviar la notificación')
      }
    },
    refresh () {
      this.showNew = false
      this.getNotificaciones()
    }
  },
  mounted () {
    this.getNotificaciones()
  },
  watch: {
    page () {
      this.getNotificaciones()
    }
  }
}
</script>
